import styled from 'styled-components';

export const PostsListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex: 1;
  overflow-y: auto;
  max-height: calc(100vh - 220px);
  padding-right: 8px;
`;

export const GroupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 16px;
  padding: 16px;
`;

export const DateGroupTitle = styled.div`
  color: ${({ theme }) => theme.colors.black9};
  font-family: ${({ theme }) => theme.fontFamily.primary};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  padding-left: 32px;
`;
